import { GenericPaginationOutput } from '../generic-dtos/genericPaginationOutput';
import {
	ContributionFromEnum,
	SingleUserContributionData
} from '../users/interfaces/ContributionData';

export interface PaginationParams {
	page: number;
	limit: number;
	contributionType?: ContributionFromEnum;
	year?: number;
	// CPSIs del plan del que se quieren las aportaciones (multi-cuenta). Un plan puede
	// abarcar varios CPSIs (fondos ACC+BON), por eso es un conjunto. El backend filtra
	// por plan de forma lenient (IN (…) OR product_code IS NULL). Se serializa directo
	// en el body del POST.
	productCodes?: number[];
	/**
	 * Plan del que se quieren los movimientos, por su `user_epp_config.id`. El backend
	 * comprueba que es del usuario y saca él sus productos (comparsa#824); si llega,
	 * manda sobre `productCodes`. Un backend anterior lo descarta (`whitelist`) y
	 * sigue filtrando por `productCodes`, por eso durante la transición viajan juntos.
	 */
	userEppConfigId?: string;
}

// Fuente única del modelo de movimiento: SingleUserContributionData (../users/interfaces/ContributionData).
// Se reexporta como ContributionData para no romper a los consumidores existentes.
export type ContributionData = SingleUserContributionData;

export interface PaginatedMonthContributions {
	month: string;
	contributions: ContributionData[];
	bonusContributions: ContributionData[];
}

const getCalculatorsUserAportations = async (
	token: string,
	params: PaginationParams
): Promise<GenericPaginationOutput<PaginatedMonthContributions>> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/calculators/user-aportations-by-type`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify(params)
		}
	);

	if (!response.ok) {
		throw new Error('Network response was not ok');
	}

	const result = await response.json();
	return result.data; // Accede al campo data en la respuesta
};

export default getCalculatorsUserAportations;
